import { Action, createReducer, on } from "@ngrx/store";
import { AppState } from "./app.state";
import {AttributeValueTypes, retrieveDocumentAttributeValuesList} from './attribute-value-actions';
import * as storage from '../storage';

export const initialAttributeValueState: AppState = {
    currentattributevalue: storage.getItem('currentattributevalue').currentattributevalue
}

// const _attributeValueReducer = createReducer(initialAttributeValueState, on(retrieveDocumentAttributeValuesList, (state, action) => {
//     return {
//         ...state,
//         currentattributevalue: action.currentattributevalue
//     }
// }));

const _attributeValueReducer = createReducer(initialAttributeValueState, on(retrieveDocumentAttributeValuesList, (state, action) => ({...state, currentattributevalue: action.currentattributevalue})));

export function attributeValueReducer(state:AppState | undefined, action:Action) : any {
    // switch(action.type) {
    //     case AttributeValueTypes.RetrieveDocumentAttributeValueType: return _attributeValueReducer(state, action);
    //     default: return state;
    // }
    return _attributeValueReducer(state, action);
}

export const getAttributeValue = (state:AppState) => {
    console.log('###########state.currentattributevalue##############')
    console.log(state.currentattributevalue)
    console.log('#########################')
    return state.currentattributevalue;
}

